import React from 'react'
import styles from './StatValue.module.scss'

type Size = 'md' | 'lg'

interface StatValueProps {
  children: React.ReactNode
  size?: Size
  className?: never
}

const sizeMap: Record<Size, string> = { md: styles.md, lg: styles.lg }

export const StatValue: React.FC<StatValueProps> = ({ children, size = 'lg' }) => (
  <span className={[styles.value, sizeMap[size]].join(' ')}>{children}</span>
)
